const toPositiveAmount = (value) => {
  if (value === '' || value === null || value === undefined) return null;
  const amount = Number(value);
  return Number.isFinite(amount) && amount > 0 ? amount : null;
};

export const buildWaterPriceConfiguration = (businessCosts) => {
  const max = toPositiveAmount(businessCosts?.maxUnitWaterPrice);
  const mineralMin = toPositiveAmount(businessCosts?.minMineralWaterPrice);
  const pureMin = toPositiveAmount(businessCosts?.minPureWaterPrice);
  const mineralDefault = toPositiveAmount(businessCosts?.mineralWaterPrice);
  const pureDefault = toPositiveAmount(businessCosts?.pureWaterPrice);

  if ([max, mineralMin, pureMin, mineralDefault, pureDefault].some((value) => value === null)) {
    return null;
  }
  if (mineralMin > max || pureMin > max
      || mineralDefault < mineralMin || mineralDefault > max
      || pureDefault < pureMin || pureDefault > max) {
    return null;
  }

  return {
    limits: {
      mineral: { min: mineralMin, max },
      pure: { min: pureMin, max }
    },
    defaults: {
      mineral: mineralDefault,
      pure: pureDefault
    }
  };
};
